import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { BrandGroupList } from './components/BrandGroupList'

export const BrandGroupListPage = () => {
  const { isLoading } = useSurveyForSettingsQuery()

  useLogEventOnMount('Access to brand group list')

  return (
    <Suspense loading={isLoading}>
      <BrandGroupList />
    </Suspense>
  )
}
